import React from "react";
import { Checkbox, Trophy } from "../assets/svg/icons";

const InstructionsList = () => {
  return (
    <ol className="instructions_list">
      <li className="instructions_list_item">
        <div className="instruction">
          <span>1</span>
          <p>Klicka på figurerna som syns på bilden.</p>
        </div>
        <img
          src="https://who-decides-test.s3.eu-north-1.amazonaws.com/%C3%A4ldreomsorg.png"
          alt="Tecknad bild på en kvinna som hjälper en äldre kvinna."
        />
      </li>
      <li className="instructions_list_item">
        <div className="instruction">
          <span>2</span>
          <p>
            Svara på frågorna genom att välja en av de 3 alternativ som visas.
          </p>
        </div>
        <Checkbox />
      </li>
      <li className="instructions_list_item">
        <div className="instruction">
          <span>3</span>
          <p>Se ditt resultat och utmana dig själv genom att spela igen.</p>
        </div>
        <Trophy />
      </li>
    </ol>
  );
};

export default InstructionsList;
